import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
export interface IFiOnboardingConfirmDeleteItemDialogResult {
    isItemDeleted: boolean;
    isItemDisabled: boolean;
}

@Component({
    selector: 'fi-onboarding-confirm-delete-item-dialog',
    templateUrl: './fi-onboarding-confirm-delete-item-dialog.component.html',
    styleUrls: ['./fi-onboarding-confirm-delete-item-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-confirm-delete-item-dialog' },
    standalone: false,
})
export class FiOnboardingConfirmDeleteItemDialogComponent extends FiDialogsContentBase<
    { message: string },
    IFiOnboardingConfirmDeleteItemDialogResult
> {
    private readonly appTextService = inject(AppTextService);
    private readonly confirmText = this.appTextService.get('common.delete').toUpperCase();
    protected confirmInputValue = '';

    protected cancelItemDelete(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.NoButton,
        });
    }

    protected disableItem(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.YesButton,
            value: {
                isItemDeleted: false,
                isItemDisabled: true,
            },
        });
    }

    protected deleteItem(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.YesButton,
            value: {
                isItemDeleted: true,
                isItemDisabled: false,
            },
        });
    }

    protected isDeleteButtonDisabled(): boolean {
        return this.confirmText !== this.confirmInputValue;
    }
}
